export default "__VITE_ASSET__QgB7M9D6__"